import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Route guard that restricts access to platform owners (user IDs in
 * OWNER_USER_IDS, surfaced as `profile.is_owner === true`). Must be used
 * inside `<ProtectedRoute>` which guarantees authentication and handles
 * the loading state.
 *
 * Note: this is a UX/redirect convenience only — the backend
 * `credits.require_owner` dependency is the authoritative trust boundary.
 * A stale client-side `is_owner=true` cannot grant actual privilege.
 *
 * CST202: introduced to replace the misuse of `AdminRoute` (which gated on
 * `role === "admin"`, a company-scoped predicate) for platform-internal
 * routes like `/admin/translations` and `/admin`.
 */
export function OwnerRoute({ children }: { children: ReactNode }) {
  const { profile } = useAuth();

  if (profile?.is_owner !== true) {
    return <Navigate to="/jobs" replace />;
  }

  return <>{children}</>;
}
